import {
  Component,
  ElementRef,
  input,
  viewChild,
  computed,
  inject,
  afterNextRender,
  effect,
} from '@angular/core';
import { ContentSectionComponent } from '@app/components/content-section/content-section.component';
import { ParagraphPgEmbed } from '@app/models/paragraph.model';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { EntitySharedModule } from '@app/modules/entity.shared.module';
import { RunScriptsDirective } from '@app/directives/run-scripts.directive';
import { HeadingSelectComponent } from '@app/components/heading-select/heading-select.component';
// import iframeResizer from 'iframe-resizer';

@Component({
  selector: 'mobi-paragraph-pg-embed',
  templateUrl: './paragraph-pg-embed.component.html',
  styleUrls: ['./paragraph-pg-embed.component.scss'],
  imports: [
    EntitySharedModule,
    ContentSectionComponent,
    RunScriptsDirective,
    HeadingSelectComponent,
  ],
  standalone: true,
})
export class ParagraphPgEmbedComponent {
  readonly paragraph = input.required<ParagraphPgEmbed>();

  readonly iframeWrapper = viewChild<ElementRef>('iframeWrapper');

  sanitized = computed<SafeHtml>(() =>
    this.#sanitizer.bypassSecurityTrustHtml(
      this.paragraph().code?.replaceAll('\n', '') || ''
    )
  );

  width = computed(() => {
    switch (this.paragraph()?.width) {
      case 'small':
        return 'sm';
      default:
        return 'lg';
    }
  });

  #frameUpdate = effect(() => {});

  #sanitizer = inject(DomSanitizer);
  #afterRender = afterNextRender({
    read: async () => {
      const iframeWrapper = this.iframeWrapper();
      if (!iframeWrapper?.nativeElement?.children?.[0]) return;
      const frame: HTMLElement = iframeWrapper.nativeElement.children[0];
      if (!frame) return;
      let src = frame.getAttribute('src') || frame.getAttribute('data-src') || '';
      if (!src) return;
      // replace tokens in iframe src
      if (this.paragraph().replaceToken) src = this.getParameterToken(src);
      frame.setAttribute('src', src);
      frame.removeAttribute('data-src');

      const baseUrlOrigin = new URL('/', src).href.slice(0, -1);
      if (frame.tagName === 'IFRAME') {
        const module = await import('iframe-resizer');
        const { iframeResizer } = module.default;
        iframeResizer({ checkOrigin: [baseUrlOrigin], log: false }, frame);
      }
    },
  });

  replaceMultiple(url: string) {
    const regex = /\[(\w+)\]/g;
    const newDataSrc = url.replace(regex, (match, param) => {
      param = param.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
      const regex = new RegExp('[\\?&]' + param + '=([^&#]*)');
      const results = regex.exec(location.search);
      const value =
        results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
      return value ? encodeURIComponent(value) : '';
    });
    const parts = newDataSrc.split('?');
    if (parts.length < 2) {
      return newDataSrc;
    }
    const queryParams = parts[1].split('&');
    const filteredParams = queryParams.filter(function (param) {
      return param.indexOf('=') !== -1 && param.split('=')[1].trim() !== '';
    });
    const newUrl = filteredParams.length
      ? parts[0] + '?' + filteredParams.join('&')
      : parts[0];

    return newUrl;
  }

  getParameterToken(src: string | null): string {
    let newSrc: string = '';
    if (src) {
      const wildcard = src.match(/\[.*?\]/g);
      if (wildcard) {
        newSrc = this.replaceMultiple(src);
      } else {
        newSrc = src;
      }
    }
    return newSrc;
  }
}
